<template>
    <div class="albums">
        <h2 class="section-title">Tour Summer 2025</h2>
        <h3>6/20 - 6/29</h3>
        <h4>| Louisville | Indianapolis | Lafayette | Chicago | Milwaukee | Tolono | St. Louis | Carbondale | Evansville |</h4>
        <div class="tour-card">
            <!-- <div> -->
                <img src="../assets/tour-flier.png" class="tour-main">

                <!-- try added sample
                <div class="day-content">
                    <h3>Day 1</h3>
                    <img src="../assets/tour-flier-day1.png" class="tour-day">
                </div>
                <div class="day-content">
                    <h3>Day 2</h3>
                    <img src="../assets/logo-round-wordless.png" class="tour-day">
                </div>
                <div class="day-content">
                    <h3>Day 3</h3>
                    <img src="../assets/logo-round-wordless.png" class="tour-day">
                </div>
                <div class="day-content">
                    <h3>Day 4</h3>
                    <img src="../assets/logo-round-wordless.png" class="tour-day">
                </div>
                <div class="day-content">
                    <h3>Day 5</h3>
                    <img src="../assets/logo-round-wordless.png" class="tour-day">
                </div>
                <div class="day-content">
                    <h3>Day 6</h3>
                    <img src="../assets/logo-round-wordless.png" class="tour-day">
                </div>
                <div class="day-content">
                    <h3>Day 7</h3>
                    <img src="../assets/logo-round-wordless.png" class="tour-day">
                </div>
                <div class="day-content">
                    <h3>Day 8</h3>
                    <img src="../assets/logo-round-wordless.png" class="tour-day">
                </div>
                <div class="day-content">
                    <h3>Day 9</h3>
                    <img src="../assets/logo-round-wordless.png" class="tour-day">
                </div> -->

                <!-- /try sample -->
            </div>
            <div class="tour-days-container">
                <div class="day-content">
                    <h3>Day 1</h3>
                    <img src="../assets/tour-flier-day1.png" class="tour-day">
                </div>
                <div class="day-content">
                    <h3>Day 2</h3>
                    <img src="../assets/logo-round-wordless.png" class="tour-day">
                </div>
                <div class="day-content">
                    <h3>Day 3</h3>
                    <img src="../assets/logo-round-wordless.png" class="tour-day">
                </div>
                <div class="day-content">
                    <h3>Day 4</h3>
                    <img src="../assets/logo-round-wordless.png" class="tour-day">
                </div>
                <div class="day-content">
                    <h3>Day 5</h3>
                    <img src="../assets/logo-round-wordless.png" class="tour-day">
                </div>
                <div class="day-content">
                    <h3>Day 6</h3>
                    <img src="../assets/logo-round-wordless.png" class="tour-day">
                </div>
                <div class="day-content">
                    <h3>Day 7</h3>
                    <img src="../assets/logo-round-wordless.png" class="tour-day">
                </div>
                <div class="day-content">
                    <h3>Day 8</h3>
                    <img src="../assets/logo-round-wordless.png" class="tour-day">
                </div>
                <div class="day-content">
                    <h3>Day 9</h3>
                    <img src="../assets/logo-round-wordless.png" class="tour-day">
                </div>

            </div>
        </div>

</template>

<script>
export default {
    name: 'TourView',
}
</script>

<style scoped>

.day-content {
    flex-direction: column;
    justify-content: center;
    flex-wrap: wrap;
}
.tour-card {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    text-align: center;
}
.tour-days-container {
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    flex-wrap: wrap;
    /* width: 80vw; */
}

.tour-main {
    width: 100%;
    margin: auto;
}
.tour-main-container {
    /* display: flex; */
}
.tour-day {
    width: 100%;
    margin: auto;
}

/* media queries */
/* adjusts the amount of tour days shown per row based on screen size */
@media only screen and (min-width: 500px) {
    .day-content {
        width: 50%;
    }
}

@media only screen and (min-width: 600px) {

    .tour-main {
        width: 70%;
    }
    .day-content {
        width: 40%;
    }

}

@media only screen and (min-width: 1000px) {

    .tour-main {
        width: 45%;
    }
    .day-content {
        width: 26%;
    }

}

</style>